import React, { Dispatch, useEffect } from "react";
import { Switch, Redirect, RouteComponentProps, useLocation, useRouteMatch } from "react-router";
import { connect, useDispatch } from "react-redux";
import { User } from "oidc-client";
import { appPaths, IAppState, ApiRequest, PageTitleSetter, appPageTitles } from "../../Common";
import { ProtectedRoute, useLoggedInUser } from "../../Auth";
import { setPath, setBreadcrumbs } from "../../Startup/Actions/StartupActions";
import { BreadcrumbData, breadcrumbService } from "../../Layout";
import { breadcrumbsMap } from "../Constants/breadcrumbsMap";
import { endpoints } from "../Constants/endpoints";
import ResponseHandler from "../../App/ResponseHandler";
import { ResponseResult } from "../../Common/Models/ResponseResult";
import TagFeedbackList from "./TagFeedbackList";
import { TagList, useTags } from "..";

const TagRoutes: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const user = useLoggedInUser();
  const tags = useTags();

  const getTagName = async (tagId?: string) => {
    let title;

    if (tagId && user && tags.loadingState.isLoaded) {
      const numId = parseInt(tagId, 10);
      const foundTag = tags.tags.find(t => t.id === numId);
      if (foundTag) {
        title = foundTag.name;
      }
    }

    return title;
  };

  const resolveVariable = async (key: string, variables: Map<string, string>) => {
    switch (key) {
      case ":tagId":
        return getTagName(variables.get(key));
      default:
        return key;
    }
  };

  const setMyBreadcrumbs = () => {
    const crumbs = breadcrumbService.createBreadcrumbs(
      location.pathname,
      breadcrumbsMap,
      resolveVariable
    );
    dispatch(setBreadcrumbs(crumbs));
  };

  useEffect(() => {
    setMyBreadcrumbs();
  }, [user, tags, location.pathname]);

  return (
    <>
      <PageTitleSetter title={appPageTitles.general} />
      <Switch>
        <ProtectedRoute exact path={appPaths.tags.details} component={TagFeedbackList} />
        <ProtectedRoute exact path={appPaths.tags.root} component={TagList} />
        <Redirect to={appPaths.notFound} />
      </Switch>
    </>
  );
};

export default TagRoutes;
